module.exports = __webpack_public_path__ + "assets/0c1f77410b98ff1ab0bbe9cfc3c388dd.svg";